module.exports = __webpack_public_path__ + "media/customizations/hylandtrail/logo-81b465ff6f12b963c93a23adf0c6ba1a.png";